/* eslint-disable no-useless-escape */
// Regex patterns from https://regexlib.com/
export const STRING_PATTERNS = {
  text: `^[A-Za-z0-9 .'?!,@€#\-_]*$`,
  specialCharacters: `^[A-Za-z0-9 @&+\\-\\(\\)?!*#\\\/]*$`,
  email: `^[a-zA-Z0-9]+(?:.[a-zA-Z0-9]+)*@[a-zA-Z0-9]+(?:.[a-zA-Z0-9]+)*$`,
  tel: `^[0-9 \\(\\)\\-\\+]+$`,
  url: `^((((H|h)(T|t)|(F|f))(T|t)(P|p)((S|s)?))://)?(www.|[a-zA-Z0-9].)[a-zA-Z0-9-.]+.[a-zA-Z]{2,6}(:[0-9]{1,5})*(/($|[a-zA-Z0-9.,;?'\\+&amp;%$#=~_-]+))*$`,
  default: `^[A-Za-z0-9 .'?!,@€#\-_]*$`,
  number: `^[0-9]$`,
  kvkNumber: `^[0-9]{8}$`,
  currency: `^([0-9]{1,3}[.]([0-9]{3}[.])*[0-9]{3}|[0-9]+)([,][0-9]{1,2})?$`,
  postalCode: `^[0-9]{4} {0,1}[A-Za-z]{2}$`,
  numbersLettersOnly: `^[A-Za-z 0-9]*$`,
  accountNumber: `^[A-Z]{2}[0-9]{2}[A-Z]{4}0[0-9]{9}$`,
};

export const REGEX_PATTERNS = {
  default: /^[A-Za-z0-9 .'?!,@€#\-_]*$/gm,
};
